<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <template slot="header">
          <button class="btn btn-info" @click="handleEdit()">
            <i class="fa fa-step-backward"></i> ย้อนกลับ
          </button>
          <h4 class="card-title mt-4">อัพเดตรายละเอียดแพลตฟอร์ม</h4>
        </template>
        <div>
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  label="วันที่"
                  type="text"
                  :value="result_data.createdAt"
                  disabled
                />
              </div>
              <div class="col-md-4">
                <fg-input
                  label="แพลตฟอร์ม"
                  type="text"
                  v-model="result_data.platform_name"
                />
              </div>
              <div class="col-md-4">
                <label> สถานะการใช้งาน</label><br />
                <el-select
                  label="สถานะการใช้งาน"
                  class="select-primary"
                  size="large"
                  :placeholder="result_data.status"
                  v-model="selects.simple"
                >
                  <el-option
                    v-for="option in selects.countries"
                    class="select-danger"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row"></div>
            <div class="row">
              <div class="col-md-12">
                <fg-input
                  label="หมายเหตุ"
                  type="text"
                  v-model="result_data.comment"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <l-button type="success" wide @click="handleSave()"
                  >แก้ไขข้อมูล</l-button
                >
              </div>
            </div>
          </form>
        </div>
      </card>
      <!-- end card -->
    </div>
  </div>
</template>
<script>
import { Checkbox, Radio, ChartCard, StatsCard } from "src/components/index";
import { Select, Option } from "element-ui";
import Swal from "sweetalert2";

var jwt = require("jsonwebtoken");
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Checkbox,
    Radio,
    ChartCard,
    StatsCard
  },
  data() {
    return {
      radios: {
        radio1: "1",
        radio2: "2",
        radio3: "2"
      },
      selects: {
        simple: "",
        countries: [
          {
            label: "เปิดใช้งาน",
            value: 1
          },
          {
            label: "ยกเลิกใช้งาน",
            value: 2
          }
        ]
      },
      checkboxes: {
        first: false,
        second: false,
        a: false,
        b: false,
        c: false,
        unchecked: false,
        checked: true,
        disabledUnchecked: false,
        disabledChecked: true
      },
      pieChart: {
        data: {
          labels: [],
          series: []
        }
      },
      pieChart1: {
        data: {
          labels: ["ไม่มีข้อมูลสรุป"],
          series: [0]
        }
      },
      isChart: false,
      result_data: [],
      accept_url: "",
      click_url: "",
      platform_name: "",
      status: ""
    };
  },
  methods: {
    handleEdit() {
      this.$router.push("/show_plateform");
    },
    async handleSave() {
      if (this.result_data.platform_name) {
        let selects = this.selects.simple
          ? this.selects.simple === 2
            ? "0"
            : "1"
          : this.status;

        let payload = {
          id: this.$route.query.id,
          platform_name: this.result_data.platform_name,
          status: selects,
          comment: this.result_data.comment
        };
        let user = JSON.parse(localStorage.getItem("user"));
        var token = jwt.sign(payload, "ABAsecretKeywweqwlinkmanager");
        let headers = {
          "Content-Type": "application/json",
          Authorization: "authorization " + user
        };
        await this.$axios
          .post("/update_platform", { payload: payload }, { headers: headers })
          .then(res => {
            if (res.data.code === 0) {
              Swal.fire({
                title: res.data.msg,
                icon: "success",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: true
              });
            } else {
              Swal.fire({
                title: res.data.msg,
                icon: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: true
              });
            }
          })
          .catch(() => {});
      } else {
        Swal.fire({
          title: "กรอกข้อมูลให้ครบ",
          icon: "error",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: true
        });
      }
    }
  },
  async mounted() {
    let user = JSON.parse(localStorage.getItem("user"));
    let payload = {
      platform_name: this.$route.query.plateform
    };
    var token = jwt.sign(payload, "ABAsecretKeywweqwlinkmanager");
    let headers = {
      "Content-Type": "application/json",
      Authorization: "authorization " + user
    };
    await this.$axios
      .post("/detail_platform", { token: token }, { headers: headers })
      .then(async res => {
        if (
          res.data.payload &&
          this.$route.query.plateform &&
          this.$route.query.id
        ) {
          this.status = res.data.payload.status;
          res.data.payload.status =
            res.data.payload.status === 1 ? "เปิดใช้งาน" : "ยกเลิกใช้งาน";
          let result_series =
            res.data.payload.device_ios +
            res.data.payload.device_web +
            res.data.payload.device_android;
          let result_labels = [];
          this.pieChart.data.labels[0] =
            (res.data.payload.device_ios * 100) / result_series > 0
              ? ((res.data.payload.device_ios * 100) / result_series).toFixed(
                  2
                ) + "%"
              : "";
          this.pieChart.data.labels[1] =
            (res.data.payload.device_web * 100) / result_series > 0
              ? ((res.data.payload.device_web * 100) / result_series).toFixed(
                  2
                ) + "%"
              : "";
          this.pieChart.data.labels[2] =
            (res.data.payload.device_android * 100) / result_series > 0
              ? (
                  (res.data.payload.device_android * 100) /
                  result_series
                ).toFixed(2) + "%"
              : "";

          this.pieChart.data.series[0] =
            (res.data.payload.device_ios * 100) / result_series > 0
              ? (res.data.payload.device_ios * 100) / result_series
              : this.pieChart.data.series.splice(0, 1);
          this.pieChart.data.series[1] =
            (res.data.payload.device_web * 100) / result_series > 0
              ? (res.data.payload.device_web * 100) / result_series
              : this.pieChart.data.series.splice(1, 1);
          this.pieChart.data.series[2] =
            (res.data.payload.device_android * 100) / result_series > 0
              ? (res.data.payload.device_android * 100) / result_series
              : this.pieChart.data.series.splice(2, 1);
          this.isChart = true;
          this.accept_url = res.data.payload.accept_platform.toString();
          this.click_url = res.data.payload.click_platform.toString();
          this.result_data = res.data.payload;
        } else {
          this.$router.push("/");
        }
      });
  }
};
</script>
<style lang="css" scoped>
.success-color {
  background-color: #00c851 !important;
}
.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.pull-right {
  float: right;
}
</style>
